// ════════════════════════════════════════════════════════════
//  online/friendship.js — FRIEND REQUESTS FROM ANYWHERE (a Mark, the partner bond, her seat)
// ════════════════════════════════════════════════════════════
//  caP'n 2026-10-20: "give me the option to click on any player's mark and add them as a
//  friend" · "players can add people's partners as friends. Like if my friend wanted to add
//  my partner and they play alone sometimes would be super cool".
//  These are ieSocial's own writes (addByUid / accept / removeFriend), copied shape for shape
//  so the friends list, every other IE game and rules.json's friends branch all agree:
//    send    mine "out" + theirs "in"   (one multi-path update: never a half-friendship)
//    accept  both "accepted"
//    decline both removed
//  The vendored kit (IEFriends / ieSocial) is NOT edited: these live title-local, so no
//  Mark-wide sweep is needed.
// ════════════════════════════════════════════════════════════
import { ref, update } from "firebase/database";
import { db } from "../firebase";
import { friendButton } from "./bondRule.js";
// = ieSocial's friendEdgePath / clipName (NAME_MAX 24), kept here so the Node harness can load this file
// (the vendored kit imports extensionless). If ieSocial ever changes either, change these the same day.
const friendEdgePath = (uid, fUid) => `profiles/${uid}/friends/${fUid}`;
const clipName = (s) => String(s || "Unclaimed").slice(0, 24);
export { friendButton };

async function write(paths) {
  try { await update(ref(db), paths); return { ok: true }; }
  catch (e) { return { ok: false, error: "Couldn't do that just now." }; }   // one quiet message: a refusal never says WHY (a block stays invisible)
}
export function sendRequest(me, myName, them, theirName) {
  const t = Date.now();
  return write({ [friendEdgePath(me, them)]: { status: "out", name: clipName(theirName), addedAt: t },
                 [friendEdgePath(them, me)]: { status: "in", name: clipName(myName), addedAt: t } });
}
export function acceptRequest(me, myName, them, theirName) {
  const t = Date.now();
  return write({ [friendEdgePath(me, them)]: { status: "accepted", name: clipName(theirName), addedAt: t },
                 [friendEdgePath(them, me)]: { status: "accepted", name: clipName(myName), addedAt: t } });
}
export function declineRequest(me, them) {
  return write({ [friendEdgePath(me, them)]: null, [friendEdgePath(them, me)]: null });
}
